<template>
  <v-list class="pt-0" density="compact">
    <div v-for="item in menuItems" :key="item.id">
      <v-list-item
        v-if="item.visible"
        class="global-side-menu__item"
        :id="item.id"
        :value="item"
        :active="activeItem == item.id"
        @click="selectItem(item)"
      >
        <template v-slot:prepend>
          <AppkitIcon class="pl-3 pr-1" :icon="item.icon" size="medium-large" />
        </template>

        <v-list-item-title class="ml-5">
          <router-link class="global-side-menu__item__text" :to="item.path!">
            <span>{{ item.title }}</span>
          </router-link>
        </v-list-item-title>
      </v-list-item>
    </div>
  </v-list>
</template>

<script setup lang="ts">
import type { SideMenuItem } from "@/models/sideMenuItem";
import AppkitIcon from "@/components/custom/AppkitIcon.vue";
import { useRouter } from "vue-router";
import { ref } from "vue";

const props = defineProps<{
  menuItems: SideMenuItem[];
  defaultActiveItem?: string;
}>();

const activeItem = ref(props.defaultActiveItem);
const router = useRouter();

function selectItem(item: SideMenuItem): void {
  activeItem.value = item.id;
  router.push(item.path);
}
</script>

<style scoped lang="scss">
.global-side-menu__item {
  border-radius: 6px;

  &__text {
    text-decoration: none;
    color: var(--dark-grey);
  }
}
</style>
